import PieChart from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import React from 'react';

import { constants } from '../../../shared/constants';

const PieChartSiteConsumption = ({ data }) => {
  if (data.length === 0) return <span>Loading...</span>;

  const item = data;
  const Battery_Kwh = Object.values(item.Battery_Charge_Discharge_Kw);
  const Grid_Kwh = Object.values(item.NetDemand_Kw);
  const Solar_Kwh = Object.values(item.PV_Generation_Kw);
  let sum_battery = 0;
  let sum_grid = 0;
  let sum_solar = 0;
  Battery_Kwh.forEach((entry) => {
    if (entry > 0) sum_battery += entry;
  });
  Grid_Kwh.forEach((entry) => {
    if (entry > 0) sum_grid += entry;
  });
  Solar_Kwh.forEach((entry) => {
    if (entry > 0) sum_solar += entry;
  });

  const sumTotal = sum_grid + sum_battery + sum_solar;
  const solarPercent = parseInt((sum_solar / sumTotal) * 100);
  const gridPercent = parseInt((sum_grid / sumTotal) * 100);
  const batteryPercent = parseInt((sum_battery / sumTotal) * 100);

  const options = {
    chart: {
      type: 'pie',
      height: '200px',
    },
    title: {
      text: '',
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        size: 140,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    series: [
      {
        name: '',
        color: '#006600',
        lineWidth: 1,
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              enabled: true,
              lineWidth: 1,
            },
          },
        },
        data: [
          {
            y: solarPercent,
            sliced: false,
            name: 'Solar',
            color: constants.colorObjLC.solar,
          },
          {
            y: batteryPercent,
            sliced: false,
            name: 'Battery',
            color: constants.colorObjLC.battery,
          },
          {
            y: gridPercent,
            sliced: false,
            name: 'Grid',
            color: constants.colorObjLC.grid,
          },
        ],
      },
    ],
  };

  return (
    <div>
      <PieChart
        highcharts={Highcharts}
        options={options}
        style={{ width: '50%' }}
      />
    </div>
  );
};

export default PieChartSiteConsumption;
